import { FilterValues } from "../../../data-model/filterValues";
import { CaseAppealsFilterKeys } from "./createFilterSections";

export interface ProcessedAppealFilterData {
  filters: Record<string, string[]>;
}

/**
 * Maps table filter selections to backend-supported appeal list filter keys.
 *
 * Supported backend filters: `appeal_status`, `appeal_type`, `response_status`.
 *
 * @param validFilters - Applied table filters from Redux
 * @returns Filter map for `pharmacy/appeal/list`
 */
export const processAppealFilterData = (
  validFilters: FilterValues[],
): ProcessedAppealFilterData => {
  const filters: Record<string, string[]> = {};

  if (!validFilters || validFilters.length === 0) {
    return { filters };
  }

  const filter = validFilters[0];
  if (!filter?.values) {
    return { filters };
  }

  Object.entries(filter.values).forEach(([filterId, filterData]) => {
    const selectedValues = filterData.values || [];
    if (selectedValues.length === 0) {
      return;
    }

    switch (filterId) {
      case CaseAppealsFilterKeys.RESPONSE_STATUS:
        filters.response_status = selectedValues;
        break;
      case CaseAppealsFilterKeys.APPEAL_TYPE:
        filters.appeal_type = selectedValues;
        break;
      case CaseAppealsFilterKeys.APPEAL_STATUS:
        filters.appeal_status = selectedValues;
        break;
      default:
        break;
    }
  });

  return { filters };
};
